import * as React from "react";
import Inner from "./Inner/Inner";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { LibraryCard } from "../../types/LibraryCard";
import addReview from "../../requests/addReview";
import { Review } from "../../types/Review";
import { useMediaQuery } from "react-responsive";
import { MOBILE_MAX_WIDTH } from "../../utils";

interface Props {
	card: LibraryCard;
	review?: Review;
	onClose: () => void;
	onPublished?: (id: number) => void;
}

export enum ReviewPopupStatus {
	Ready,
	Sending,
	Success,
	Error,
}

const ReviewPopup: React.FC<Props> = (props) => {
	const [status, setStatus] = React.useState(ReviewPopupStatus.Ready);

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH })

	const publishReview = (mark: number, review: string, recommend?: boolean) => {
		setStatus(ReviewPopupStatus.Sending);

		const request = async () => {
			const result = await addReview({
				review: {
					mark,
					review,
					bookId: props.card.book.id,
					isRecommend: recommend,
					id: props.review?.id,
				},
			});

			if (result && !(result as any)["errors"]) {
				props.onPublished(result);

				setStatus(ReviewPopupStatus.Success);
			} else {
				setStatus(ReviewPopupStatus.Error);
			}
		};

		request();
	};

	return (
		<Dialog open={true} scroll="body" onClose={props.onClose} fullScreen={isMobile}>
			<Inner
				book={props.card.book}
				onClose={props.onClose}
				onSend={publishReview}
				isLoading={status === ReviewPopupStatus.Sending}
				isSuccess={status === ReviewPopupStatus.Success}
				isError={status === ReviewPopupStatus.Error}
				review={props.review}
			/>
		</Dialog>
	);
};

export default ReviewPopup;
